import React, { Component, Fragment } from 'react';
import MUIDataTable from 'mui-datatables';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';

import withNotification from '../../components/HOCNotification/HOCNotification.component';
import Services from '../../services/service';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { getMuiTheme, tableOptions } from '../../util/MuiTableTheme';

class ScheduleApproval extends Component {
  constructor(props){
    super(props);

    this.state = {
      listSchedule: [],
      statusModal: false,
      selectedItem: [],
      scheduleType: "",
      confirmationModal: false,
      setStatus: ""
    }
  }

  componentDidMount(){
    this.getScheduleData();
  }

  getScheduleData = () => {
    const param = {
      params: {
        status: ""
      }
    };

    Services.getScheduleByStatus(param)
      .then(res => {
        this.setState({ listSchedule: res})
      })
      .catch(err => this.props.addNotification('danger', 'Failed', 'Oops something went wrong !', 'top-right'));
  }

  handleUpdateSchedule = () => {
    const { selectedItem, newStatus } = this.state;
    const payload = {
      scheduleId: selectedItem._id,
      newStatus
    };

    Services.postChangeStatus(payload)
      .then(res => {
        this.props.addNotification('success', 'Success', `Update successfull`, 'top-right');
        this.toggleConfirmationModal();
        this.getScheduleData();
      })
      .catch(err => {
        this.props.addNotification('danger', 'Failed', 'Oops something went wrong !', 'top-right');
        this.toggleConfirmationModal();
      })
  }

  handleApproveSchedule = () => {
    const { selectedItem } = this.state;
    const payload = {
      formId: selectedItem._id,
    };

    Services.postApproveSchedule(payload)
      .then(res => {
        this.props.addNotification('success', 'Success', `Update successfull`, 'top-right');
        this.toggleConfirmationModal();
        this.getScheduleData();
      })
      .catch(err => {
        this.props.addNotification('danger', 'Failed', 'Oops something went wrong !', 'top-right');
        this.toggleConfirmationModal();
      })
  }

  handleRejectSchedule = () => {
    const { selectedItem } = this.state;
    const payload = {
      formId: selectedItem._id,
    };

    Services.postRejectSchedule(payload)
      .then(res => {
        this.props.addNotification('success', 'Success', `Update successfull`, 'top-right');
        this.toggleConfirmationModal();
        this.getScheduleData();
      })
      .catch(err => {
        this.props.addNotification('danger', 'Failed', 'Oops something went wrong !', 'top-right');
        this.toggleConfirmationModal();
      })
  }

  toggleModal = (item={}) => {
    this.setState({ 
      selectedItem: item,
      statusModal: !this.state.statusModal
    });
  };

  toggleConfirmationModal = () => {
    this.setState({
      statusModal: false,
      confirmationModal: !this.state.confirmationModal
    })
  }

  handleFieldChange = (key) => (e) => {
    const state = { [key]: e.target.value };
    this.setState(state);
  };

  renderBreadcrumb = () => (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
        <li className="breadcrumb-item active">Approval Jadwal</li>
      </ol>
      <h1 className="page-header">Approval Jadwal</h1>
    </div>
  );

  renderScheduleTable = () => {
    const { listSchedule } = this.state;

    const columns = [
      {
        name: "no",
        label: "No",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1
        }
      },
      {
        name: "type",
        label: "Tipe",
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: "title",
        label: "Judul",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "division",
        label: "Divisi",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "start_date",
        label: "Start Date",
        options: {
          filter: true,
          sort: true,
          // customBodyRender: value => moment(value).format('DD-MM-YYYY')
        }
      },
      {
        name: "end_date",
        label: "End Date",
        options: {
          filter: true,
          sort: true,
          // customBodyRender: value => moment(value).format('DD-MM-YYYY')
        }
      },
      {
        name: "asset",
        label: "Asset",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "selectedTimeRemainderList",
        label: "Jam",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "_id",
        label: "Aksi",
        options: {
          filter: false,
          sort: false,
          setCellProps: () => ({ style: { minWidth: "200px", maxWidth: "200px" }}),
          customBodyRender: (value) => {
            return (
              <div className="with-btn text-nowrap">
                <button 
                  className="btn btn-sm btn-primary width-60 m-r-2"
                  onClick={() => {
                    const data = listSchedule.find(item => item._id === value);
                    this.toggleModal(data);
                  }}
                >View</button>
              </div>
            );
          }
        }
      }
    ];
      
    return (
      <MuiThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          title={"List Schedule"}
          data={listSchedule}
          columns={columns}
          options={tableOptions}
        />
      </MuiThemeProvider>
    )
  };

  renderModal = () => {
    const { statusModal, selectedItem } = this.state;
    const {
      division,
      type,
      title,
      start_date,
      end_date,
      selectedTimeRemainderList,
      asset
    } = selectedItem;
    const isNew = selectedItem.status === 1;

    return (
      <Modal isOpen={statusModal} toggle={() => this.toggleModal()}>
        <ModalHeader toggle={() => this.toggleModal()}>Approval</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Schedule Type</label>
            <input 
              onChange={this.handleFieldChange('scheduleType')}
              type="text"
              className="form-control"
              value={type}
              disabled
              required
            />
            <label>Judul</label>
            <input 
              onChange={this.handleFieldChange('judul')}
              type="text"
              className="form-control"
              value={title}
              disabled
              required
            />
            <label>Divisi</label>
            <input 
              onChange={this.handleFieldChange('divisi')}
              type="text"
              className="form-control"
              value={division}
              disabled
              required
            />
            <label>Start Date</label>
            <input 
              onChange={this.handleFieldChange('start_date')}
              type="text"
              className="form-control"
              value={start_date}
              disabled
              required
            />
            <label>End Date</label>
            <input 
              onChange={this.handleFieldChange('end_date')}
              type="text"
              className="form-control"
              value={end_date}
              disabled
              required
            />
            <label>Asset</label>
            <input 
              onChange={this.handleFieldChange('asset')}
              type="text"
              className="form-control"
              value={asset}
              disabled
              required
            />
            <label>Jam</label>
            <input 
              onChange={this.handleFieldChange('selectedTimeRemainderList')}
              type="text"
              className="form-control"
              value={selectedTimeRemainderList}
              disabled
              required
            />
          </div>

        </ModalBody>
        <ModalFooter>
          {/* {
            isNew ? (
              <Fragment>
              <button className="btn btn-primary" onClick={()=> this.setState({ newStatus: 2}, this.toggleConfirmationModal())} type="submit">Approve</button>
              <button className="btn btn-danger" onClick={()=> this.setState({ newStatus: 3}, this.toggleConfirmationModal())} type="submit">Reject</button>
              </Fragment>
            ) :
            (
              <>
              <button className="btn btn-danger" onClick={()=> this.toggleConfirmationModal()} type="submit">Verifikasi</button>
              <button className="btn btn-danger" onClick={()=> this.setState({ newStatus: 3}, this.toggleConfirmationModal())} type="submit">Delete</button>
              </>
            )
          } */}
              <>
              <button className="btn btn-primary" onClick={()=> this.toggleConfirmationModal()} type="submit">Verifikasi</button>
              <button className="btn btn-danger" onClick={()=> this.handleRejectSchedule()} type="submit">Reject</button>
              </>
          <button className="btn btn-white" onClick={this.toggleModal}>Cancel</button>
        </ModalFooter>
      </Modal>
    )
  }

  renderConfirmationModal = () => {
    const { confirmationModal } = this.state;
    return (
      <Modal isOpen={confirmationModal} toggle={() => this.toggleConfirmationModal()}>
        <ModalHeader toggle={() => this.toggleConfirmationModal()}>Confirmation</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <h3>Are you sure ?</h3>
          </div>

        </ModalBody>
        <ModalFooter>
          <button className="btn btn-primary" onClick={this.handleApproveSchedule}>Yes</button>
          <button className="btn btn-danger" onClick={this.toggleConfirmationModal}>No</button>
        </ModalFooter>
      </Modal>
    )
  }

  render(){
    return(
      <div>
        {this.renderBreadcrumb()}
        {this.renderScheduleTable()}
        {this.renderModal()}
        {this.renderConfirmationModal()}
      </div>
    )
  }

}

export default withNotification(ScheduleApproval);